<form
  *ngIf="!alertMessage || alertMessage.type !== 'success'"
  class="form mb-3"
  [formGroup]="customerForm"
  (ngSubmit)="onSubmit()"
>
  <!-- Company info -->
  <lib-gung-text-input
    gungTranslate="COMPANY_NAME"
    formControlName="companyName"
    placeholder="{{ 'ENTER_COMPANY_NAME' | translate }}"
    ngbAutofocus
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="ORG_NUMBER"
    formControlName="companyOrganisationId"
    placeholder="{{ 'ORG_NUMBER' | translate }}"
  ></lib-gung-text-input>

  <!-- Delivery address -->
  <h6 class="mt-3" translate>DELIVERY_ADDRESS</h6>

  <div formGroupName="extra">
    <lib-gung-text-input
      gungTranslate="STREET_ADDRESS"
      formControlName="companyAddress"
      placeholder="{{ 'ENTER_ADDRESS' | translate }}"
    ></lib-gung-text-input>
  </div>

  <lib-gung-text-input
    gungTranslate="POSTAL_CODE"
    formControlName="deliveryPostalCode"
    placeholder="{{ 'POSTAL_CODE' | translate }}"
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="CITY"
    formControlName="deliveryCity"
    placeholder="{{ 'CITY' | translate }}"
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="COUNTRY"
    formControlName="deliveryCountry"
    placeholder="{{ 'COUNTRY' | translate }}"
  ></lib-gung-text-input>

  <!-- Billing address -->
  <h6 class="mt-3" translate>BILLING_ADDRESS</h6>
  <div class="gung-toggle-switch d-flex align-items-center mb-2">
    <label class="switch mb-0 me-2">
      <input
        type="checkbox"
        formControlName="sameAsDelivery"
        (change)="onSameAsDeliveryChange()"
      />
      <span class="slider round"></span>
    </label>
    <span translate>SAME_AS_DELIVERY_ADDRESS</span>
  </div>

  <lib-gung-text-input
    gungTranslate="BILLING_COMPANY_NAME"
    formControlName="billingCompanyName"
    placeholder="{{ 'ENTER_COMPANY_NAME' | translate }}"
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="STREET_ADDRESS"
    formControlName="billingStreet"
    placeholder="{{ 'ENTER_ADDRESS' | translate }}"
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="POSTAL_CODE"
    formControlName="billingPostalCode"
    placeholder="{{ 'POSTAL_CODE' | translate }}"
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="CITY"
    formControlName="billingCity"
    placeholder="{{ 'CITY' | translate }}"
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="COUNTRY"
    formControlName="billingCountry"
    placeholder="{{ 'COUNTRY' | translate }}"
  ></lib-gung-text-input>

  <!-- Contact -->
  <h6 class="mt-3" translate>CONTACT_INFORMATION</h6>

  <lib-gung-text-input
    gungTranslate="CONTACT_PERSON"
    formControlName="contactPerson"
    placeholder="{{ 'ENTER_CONTACT' | translate }}"
  ></lib-gung-text-input>

  <lib-gung-text-input
    gungTranslate="PHONE"
    formControlName="phone"
    placeholder="{{ 'ENTER_PHONE' | translate }}"
  ></lib-gung-text-input>

  <div class="email-field">
    <lib-gung-text-input
      gungTranslate="EMAIL"
      formControlName="email"
      placeholder="{{ 'ENTER_EMAIL' | translate }}"
    ></lib-gung-text-input>
    <lib-forms-message-error [controller]="getFormControl('email')"></lib-forms-message-error>
  </div>

  <div class="email-field">
    <lib-gung-text-input
      gungTranslate="INVOICE_EMAIL"
      formControlName="invoiceEmail"
      placeholder="{{ 'ENTER_EMAIL' | translate }}"
    ></lib-gung-text-input>
    <lib-forms-message-error [controller]="getFormControl('invoiceEmail')"></lib-forms-message-error>
  </div>

  <lib-gung-text-input
    gungTranslate="WEBSITE"
    formControlName="website"
    placeholder="{{ 'WEBSITE' | translate }}"
  ></lib-gung-text-input>

  <div class="form-group mt-3" formGroupName="extra">
    <label class="font-weight-bold" translate>ADDITIONAL_INFO</label>
    <textarea
      class="form-control"
      formControlName="additionalInfo"
      rows="3"
      placeholder="{{ 'ADDITIONAL_INFO_PLACEHOLDER' | translate }}"
    ></textarea>
  </div>

  <div *ngIf="alertMessage" class="alert mt-2 text-center" [ngClass]="'alert-' + alertMessage.type" role="alert">
    <span>{{ alertMessage.message | translate }}</span>
  </div>
  <button class="btn btn-primary mt-3 w-100" type="submit" [disabled]="loader ? true : null">
    <span>{{ getButtonText(customerForm.valid || loader) }}</span>
    <i *ngIf="loader" class="fas fa-spinner fa-spin ml-2"></i>
  </button>
</form>

<div *ngIf="alertMessage && alertMessage.type === 'success'" class="alert alert-success mt-2 text-center" role="alert">
  <span>{{ alertMessage.message | translate }}</span>
</div>
<button
  *ngIf="alertMessage && alertMessage.type === 'success'"
  class="btn btn-primary mt-2 w-100"
  type="button"
  (click)="alertMessage = null"
>
  <span translate>CREATE_NEW</span>
</button>
<a class="login-instead-text" (click)="$event.stopPropagation(); returnToLogin.emit()" translate>LOGIN_INSTEAD</a>
